import { FaAngleDown } from 'react-icons/fa';
import styled, { css } from 'styled-components';

import Button from '../..//Atoms/Button';

import { Color } from '../../../shared/constants/Colors';
import { Indexes, Shadow } from '../../../shared/constants/Styles';

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const StyledButton = styled(Button)`
  & {
    border: none;
  }

  &:focus {
    border: none;
    background: ${Color.WHISPER};
  }

  &:focus:not(:focus-visible) {
    outline: none;
    background-color: transparent;
  }

  color: ${({ isOpen }) => (isOpen ? Color.BLUE_RIBBON : Color.CLOUD_BURST)};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: fit-content;
  position: relative;

  &:hover {
    ${StyledButton} {
      color: ${Color.BLUE_RIBBON};
    }
  }
`;

export const AngleIcon = styled(FaAngleDown)`
  && {
    color: ${({ isOpen }) => (isOpen ? Color.BLUE_RIBBON : Color.CLOUD_BURST)};
    transition: transform 0.3s ease, color 0.3s ease;
    ${({ isOpen }) =>
      isOpen &&
      css`
        transform: translate(25%) rotate(-180deg);
      `}
  }
`;

export const DropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 16px);
  left: 0;
  z-index: ${Indexes.MODAL};
  padding: 8px;
  background: ${Color.WHITE};
  border-radius: 8px;
  box-shadow: ${Shadow.DEEP_BLUE_ACTIVE};

  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
  transform: ${({ isVisible }) =>
    isVisible ? 'translate(0%, 0)' : 'translate(0%, -10px)'};
  transition: opacity 0.3s ease, transform 0.3s ease;

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 35px;
    transform: translateX(-50%) rotate(45deg);
    width: 12px;
    height: 12px;
    background: ${Color.WHITE};
    box-shadow: -1px -1px 2px rgba(20, 60, 120, 0.05);
    z-index: -1;
  }
`;

export const ContentWrapper = styled.div`
  transition: opacity 0.3s ease;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
`;

export const SectionWrapper = styled.div`
  display: flex;
`;
